import { useEffect, useState } from "react"
import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { ApiTypes, UITypes } from "types"

import { CustomerMembershipTypesModal } from "modals/CustomerMembershipTypesModal"

interface CustomerMembershipTypeProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const MembershipTypeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  span {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: var(--text-primary);
    padding: 4px 8px;
    background-color: var(--surface-3);
    border-radius: 6px;
  }
`

export const CustomerMembershipType = ({ cell: { getValue, row } }: CustomerMembershipTypeProps) => {
  const [customerMemberships, setCustomerMemberships] = useState<{
    currentCustomer: string
    types: string[]
  } | null>(null)
  const memberships = getValue().value
  const membershipRows = Array.isArray(memberships)
    ? memberships.filter(
        (membership): membership is ApiTypes.Model.CustomerMemberships => "membership_type" in membership,
      )
    : []
  const currentCustomer = row.original.homeowner_name.value as string
  const [membershipTypes, setMembershipTypes] = useState<string[]>([])
  const [currentMembershipType, setCurrentMembershipType] = useState<string>("")

  if (membershipRows.length === 0) {
    return null
  }

  const getMembershipTypes = () => {
    return membershipRows
      .filter(membership => !!membership.membership_type)
      .map(membership => membership.membership_type?.st_name || "")
  }

  const getCurrentMembershipType = () => {
    return membershipRows[0].membership_type?.st_name || ""
  }

  useEffect(() => {
    setMembershipTypes(getMembershipTypes())
    setCurrentMembershipType(getCurrentMembershipType())
  }, [])

  const handleShowMembershipTypes = () => {
    setCustomerMemberships({ currentCustomer, types: membershipTypes })
  }

  return (
    <>
      <MembershipTypeContainer onClick={handleShowMembershipTypes}>
        <span>{currentMembershipType}</span>
        {membershipTypes.length > 1 && <span>+{membershipTypes.length - 1}</span>}
      </MembershipTypeContainer>
      {customerMemberships && (
        <CustomerMembershipTypesModal
          membershipTypes={customerMemberships.types}
          currentCustomer={customerMemberships.currentCustomer}
          onCancel={() => setCustomerMemberships(null)}
        />
      )}
    </>
  )
}
